import React from 'react';

function formatLectureDate(date) {
  if (!date) return '';

  const parsedDate = new Date(`${date}T00:00:00`);
  if (Number.isNaN(parsedDate.getTime())) return '';

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(parsedDate).replace(/ /g, '-');
}

function LectureCard({ lecture, index, onClick }) {
  const formattedDate = formatLectureDate(lecture.lectureDate);
  const thumbSrc = lecture.thumbnailUrl;

  return (
    <div
      className="lecture-card"
      onClick={() => onClick(index)}
      role="button"
      tabIndex={0}
      aria-label={`Lecture ${lecture.lectureNumber}: ${lecture.title}`}
    >
      <div className="lecture-info">
        <h3 className="lecture-title">
          {lecture.title}
          {formattedDate && `: ${formattedDate}`}
        </h3>
        {lecture.language && <span className="lecture-language">{lecture.language}</span>}
        {lecture.description && (
          <p className="lecture-description">{lecture.description}</p>
        )}
      </div>
      <div className="lecture-thumbnail" aria-hidden="true">
        {thumbSrc ? (
          <img
            src={thumbSrc}
            alt={lecture.title}
            loading="lazy"
            decoding="async"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
              borderRadius: '0.25rem',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <svg viewBox="0 0 24 24" className="play-overlay" aria-label="Play lecture">
            <polygon points="13 2 3 9 12 9 19 9 13 2" fill="white" />
            <path d="M13 L19 L13 14 Z" fill="white" />
          </svg>
        )}
        <div
          className="play-overlay"
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '40px',
            height: '40px',
            background: 'rgba(0,0,0,0.6)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="white" style={{ marginLeft: '2px' }}>
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default function LectureGrid({ lectures, onLectureClick }) {
  if (!lectures || lectures.length === 0) {
    return <div className="lecture-grid-empty">No lectures available</div>;
  }

  return (
    <div className="lecture-grid" role="grid" aria-label="Lectures grid">
      {lectures.map((lecture, index) => (
        <LectureCard
          key={lecture.id}
          lecture={lecture}
          index={index}
          onClick={onLectureClick}
        />
      ))}
    </div>
  );
}
